import Button from '@components/Button'
import { useDevMode } from '@plug-core/state'
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  useTheme,
} from '@mui/material'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HiMiniPencil } from 'react-icons/hi2'

import type { Network } from '@plug-core/interfaces/common'

const NetworkList = () => {
  const navigate = useNavigate()

  const theme = useTheme()
  const { networks, setActiveNetwork, activeNetwork, devEnabled } = useDevMode()

  const activateNetwork = (network: Network) => {
    setActiveNetwork(network.id)
    navigate(-1)
  }

  const renderNetworkRow = (network: Network) => (
    <ListItem key={network.id} onClick={() => activateNetwork(network)}>
      <ListItemText
        primary={network.name}
        secondary={network.hostUrl}
        primaryTypographyProps={{
          color: activeNetwork === network.id ? theme.palette.rainbow.green : 'white',
        }}
      />
      <ListItemSecondaryAction>
        <IconButton
          color="secondary"
          onClick={() => navigate(ROUTES.DEVELOPER_SETTINGS_EDIT_NETWORK(network.id))}
        >
          <HiMiniPencil color="white" size={15} />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  )

  return (
    <Stack mx={2}>
      <List>{Object.values(networks).map(renderNetworkRow)}</List>
      <Button
        variant="rainbow"
        onClick={() => navigate(ROUTES.DEVELOPER_SETTINGS_NEW_NETWORK)}
        fullWidth
      >
        Create Network
      </Button>
    </Stack>
  )
}

export default NetworkList
